<template>
  <div class="box box_v wrapper">
    <div class="header-wrapper box">
      <div class="header">{{this.comeType == '11'?'居民议事厅':'党委联席会议'}}</div>
      <div class="addManager">
        <Button class="bkcc-btn" type="primary" @click="newAssembly">发布</Button>
      </div>
    </div>
    <div class="content box_f1">
      <Card class="card-wrappper1" v-if="isJiedao == 1">
        <div class="select-wrapper">
          <label for>行政区域</label>
          <Select
            v-model="communityId"
            class="input"
            style="width: 505px;margin-left: 20px"
            @on-change="changeCommunity"
          >
            <Option v-for="item in childShequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>
      </Card>
      <Card style="height: 100%" class="card-wrapper2">
        <div class="ass-wrap box" v-for="(item, index) in assList" :key="index" @click="toDetail(index)">
          <img :src="item.cover" v-if="item.cover" class="box" alt />
          <div class="box_f1 ass-con">
            <p class="ass-title">
                {{item.title}}
                <i class="cancel" v-if="item.status == 2">（已取消）</i>
            </p>
            <!-- <p v-if="item.status == 2">已取消</p> -->
            <p class="ass-time">{{item.time}}</p>
          </div>
          <div class="box box btn-con">
            <div class="ass-btn" @click.stop="toDetail(index)">详情</div>
            <div class="ass-btn" @click.stop="edit(index)">编辑</div>
            <div class="ass-btn" v-if="item.status != 2" @click.stop="showCancelAss(index)">取消</div>
            <div class="ass-btn" @click.stop="showDelAss(index)">删除</div>
          </div>
        </div>
        <p class="none" v-if="assList.length == 0">暂无数据</p>
        <div class="page">
          <Page
            :total="total"
            :current="page"
            :page-size="5"
            @on-change="handleChangePage"
            show-total
          />
        </div>
      </Card>
    </div>
    <!-- 删除Modal -->
    <Modal v-model="showDel" title="删除" @on-ok="delAss">
      <p style="color: #d22c2d;text-align: center">确定删除本次议事厅吗？删除后数据将无法恢复</p>
    </Modal>
    <!-- 取消Modal -->
    <Modal v-model="showCancel" title="取消会议" @on-ok="cancelAss">
      <p style="color: #d22c2d;text-align: center">确定取消本次会议吗？</p>
    </Modal>
    <Spin fix v-if="isTableLoading"></Spin>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comeType:'',
      page: 1,
      rows: 5,
      assList: [],
      total: 0,
      communityId: '',
      childShequ: [],
      delIndex: "",
      showDel: false,
      showCancel: false,
      isTableLoading: false,
      cancelIndex: ''
    };
  },
  watch: {
    // $route(){
    //   this.comeType = this.$route.params.comeType
    // },
    comeType(n ,o){
      console.log(this.communityId)
      var val1 = this.communityId
      var index = String(val1).indexOf(',')
      var idlist = index == -1 ? [val1] : val1.split(',')
      this.page = 1
      this.getList(idlist);
        // this.getList([this.communityId])
    },
    '$route.query' () {//'$route.query' 这个函数是关键
      Object.assign(this.$data, this.$options.data())//将跳转前的数据置空
      this.init()//再初始化当前的页面
    }
  },
  methods: {
    getList(communityIdList) {
      var url = this.urlobj.assemblyList;
      var data = {
        pageNum: this.page,
        pageSize: this.rows,
        communityIdList,
        comeType:this.comeType
      };
      this.isTableLoading = true;
      this.$post(url, data)
        .then(res => {
          var list = [];
          this.total = res.total;
          this.isTableLoading = false;
          res.rows.forEach(item => {
            var cover = "";
            //获取封面图
            item.attachmentList.forEach(_item => {
              if (_item.isResult == 0) {
                cover = _item.attachmentUrl;
                return;
              }
            });
            list.push({
              status: item.status,
              title: item.title,
              cover,
              id: item.id,
              time: item.beginTime.substr(0, item.beginTime.length - 2)
            });
          });
          this.assList = list;
        })
        .catch(e => {
          this.isTableLoading = false;
          this.$Message.error("列表加载失败");
        });
    },
    handleChangePage(val) {
      var val1 = this.communityId
      var index = String(val1).indexOf(',')
      var idlist = index == -1 ? [val1] : val1.split(',')
      this.page = val;
      this.getList(idlist);
    },
    getChildShequ() {
      var url = this.urlobj.getChildShequ;
      this.$get(url).then(res => {
        var ids = res.rows.map(item => {
          return item.communityId
        })
        this.getList(ids);
        ids = ids.join(',')
        this.communityId = ids
        var item = {
          name: '全部',
          id: ids
        }
        var list = res.rows.map(item => {
          return {
            name: item.communityName,
            id: item.communityId
          };
        });
        list.unshift(item)
        this.childShequ = list
      });
    },
    changeCommunity(val) {
      console.log(this.communityId)
      var index = String(val).indexOf(',')
      var idlist = index == -1 ? [val] : val.split(',')
      console.log(idlist)
      this.page = 1
      this.getList(idlist);
    },
    showDelAss(index) {
      this.showDel = true;
      this.delIndex = index;
    },
    delAss() {
      var id = this.assList[this.delIndex].id;
      var url = this.urlobj.delAss(id);
      this.isTableLoading = true;
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.isTableLoading = false;
          this.$Message.success("删除成功");
          this.page = 1
          this.getList();
        }
      });
    },
    toDetail(index) {
      var id = this.assList[index].id;
      var comeType = this.comeType
      this.$router.push({ name: "assemblyDetail", query: { id,comeType } });
    },
    newAssembly() {
       var comeType = this.comeType
      this.$router.push({ name: "assemblyNew" , query: { comeType }});
    },
    edit(index) {
      var id = this.assList[index].id;
      var comeType = this.comeType
      this.$router.push({ name: "assemblyNew", query: { id,comeType } });
    },
    showCancelAss(index) {
      this.showCancel = true
      this.cancelIndex = index
    },
    cancelAss() {
      var id = this.assList[this.cancelIndex].id;
      var url = this.urlobj.delAss(id);
      url += '?status=2'
      this.isTableLoading = true;
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.isTableLoading = false;
          this.$Message.success("取消成功");
          this.getList();
        }
      });
    },
    init () {
      this.communityId = parseInt(this.$store.state.streetorcommunityid)
      this.comeType = this.$util.getUrlKey('comeType')
      this.getList([this.communityId]);
      if (this.$store.state.isJiedao == 1) {
        this.getChildShequ();
      }
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  computed: {
    isJiedao() {
      console.log(this.$store.state.isJiedao);
      return this.$store.state.isJiedao;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  margin: 20px;
}
.card-wrappper1 {
  margin-bottom: 20px;
}
.ass-wrap {
  // height: 200px;
  border-bottom: 1px solid #ddd;
  padding: 0 0 20px 0;
  margin-bottom: 20px;
  img {
    width: 200px;
    height: 100px;
    border-radius: 4px;
  }
  .ass-title {
    font-size: 16px;
    color: #333;
    margin-top: 10px;
  }
  .ass-time {
    font-size: 16px;
    color: #999;
    margin-top: 40px;
  }
  .ass-con {
    margin-left: 20px;
  }
  .ass-btn {
    width: 60px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #dedede;
    margin-right: 20px;
  }
  .btn-con {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.none {
  font-size: 16px;
  color: #666666;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
}
.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.cancel {
  color: #ff7c43
}
</style>
